import { render, staticRenderFns } from "./html.vue?vue&type=template&id=2c916fee&scoped=true"
import script from "./html.vue?vue&type=script&lang=js"
export * from "./html.vue?vue&type=script&lang=js"
import style0 from "./html.vue?vue&type=style&index=0&id=2c916fee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c916fee",
  null
  
)

export default component.exports